import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Paper,
  Switch,
  Tooltip,
  Typography,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { fetchOrgSettingsRequest, updateOrgSettingsRequest } from '../../../api/organizations/orgSlice';
import { showSnackbar } from '../../../api/snackbarSlice';

const AutoNumberSettingSection = () => {
  const dispatch = useDispatch();
  const { settings } = useSelector((state) => state.org);

  const [autoNumberGeneration, setAutoNumberGeneration] = useState(false);

  useEffect(() => {
    dispatch(fetchOrgSettingsRequest());
  }, [dispatch]);

  useEffect(() => {
    if (settings) {
      setAutoNumberGeneration(settings?.auto_document_number_generation || false);
    }
  }, [settings]);

  const handleSubmit = (updatedAutoNumberGen) => {
    dispatch(
      updateOrgSettingsRequest({
        updates: updatedAutoNumberGen,
      }),
    );
    dispatch(
      showSnackbar({
        open: true,
        message: 'Organization settings updated successfully',
        severity: 'success',
      }),
    );
  };

  return (
    <Paper elevation={0} sx={{ pl: '1rem' }}>
      <Typography variant="h6" sx={{ mb: '1.5rem', mt: '1.5rem' }}>
        Auto Number Generation
        <Divider sx={{ mt: 1 }} />
      </Typography>
      <Grid container>
        <Grid size={4.5}>
          <FormGroup row>
            <FormControlLabel
              control={
                <Switch
                  checked={autoNumberGeneration}
                  onChange={() => {
                    setAutoNumberGeneration(!autoNumberGeneration);
                    handleSubmit({ auto_document_number_generation: !autoNumberGeneration });
                  }}
                />
              }
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  {'Auto Document Number Generation'}
                  <Tooltip title="When enabled, document numbers will be generated automatically.">
                    <IconButton size="small">
                      <InfoOutlinedIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>
              }
              labelPlacement="start"
              sx={{ ml: 0, justifyContent: 'space-between', width: '100%' }}
            />
          </FormGroup>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default AutoNumberSettingSection;
